import { c as _c } from "react/compiler-runtime";
import { getOrgPlaybooksByIdOptions } from '@onefootprint/fetch-dashboard';
import { useQueries } from '@tanstack/react-query';

// Batch-resolve playbook names by id for frames that arrive without one (route-derived contexts lag
// store hydration; some Percy emissions omit it). Returns a map of id → name for those that resolved;
// callers fall back to the id otherwise.
export const usePlaybookNames = playbookIds => {
  const $ = _c(7);
  let t0;
  if ($[0] !== playbookIds) {
    t0 = playbookIds.map(_temp);
    $[0] = playbookIds;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      queries: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const results = useQueries(t1);
  let names;
  if ($[4] !== playbookIds || $[5] !== results) {
    names = new Map();
    playbookIds.forEach((id_0, i) => {
      const name = results[i]?.data?.publishedVersion?.name;
      if (name) {
        names.set(id_0, name);
      }
    });
    $[4] = playbookIds;
    $[5] = results;
    $[6] = names;
  } else {
    names = $[6];
  }
  return names;
};
function _temp(id) {
  return {
    ...getOrgPlaybooksByIdOptions({
      path: {
        id
      }
    }),
    enabled: !!id
  };
}